// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dash__header {
  background-color: #021859;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100vw;
  padding: 2%;
  height: 8vh;
}
.dash__header h1 {
  font-size: 1.5rem;
  text-transform: uppercase;
}
.dash__header h1 span {
  color: #BF1a1a;
}

.dash__history {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 30vw;
  height: 85vh;
  border-radius: 1rem;
  padding: 2%;
  overflow-y: scroll;
  background-color: #f2f2f2;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
}
.dash__history::-webkit-scrollbar {
  display: none;
}
.dash__history label {
  font-size: 1.2rem;
  align-self: flex-start;
  color: #333;
  font-weight: bolder;
}
.dash__history .dash__search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95%;
}
.dash__history .dash__search .dash__search {
  border: none;
  height: 3vh;
  border-radius: 0.5rem;
}
.dash__history .dash__repairs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 2%;
  width: 30vw;
}
.dash__history .dash__repairs .repair__card {
  width: 8vw;
  height: 10vh;
  background-color: #BFBFBF;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.5rem;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
}
.dash__history .dash__repairs .repair__card h4 {
  font-size: 1.1rem;
  color: #333;
  margin: 1% auto;
}
.dash__history .dash__repairs .repair__card h5 {
  color: #BF1a1a;
  font-size: 1.1rem;
}
.dash__history .dash__open {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 30vw;
  background-color: #f2f2f2;
  border-radius: 0.5rem;
  margin-top: 2vh;
  min-height: 40vh;
}
.dash__history .dash__open hr {
  border: 2px solid #021859;
  width: 100%;
}
.dash__history .dash__open .repair {
  border-collapse: collapse;
  width: 100%;
}
.dash__history .dash__open .repair thead, .dash__history .dash__open .repair tr, .dash__history .dash__open .repair th, .dash__history .dash__open .repair tbody {
  height: 3vh;
}
.dash__history .dash__open .repair thead {
  border-bottom: 2px solid #E4FFFF;
  background-color: #021859;
  color: #f2f2f2;
}
.dash__history .dash__open .repair tbody tr:nth-child(even) {
  background-color: #b3b3b3;
  color: #fff;
}
.dash__history .search__result {
  background-color: #fff;
  width: 30vw;
  border-radius: 0.5rem;
  max-height: 20vh;
  overflow-y: scroll;
}
.dash__history .search__result table {
  width: 100%;
}
.dash__history .search__result table thead {
  border-bottom: 2px solid #E4FFFF;
}
.dash__history .search__result table tbody tr:nth-child(even) {
  background-color: #b3b3b3;
  color: #fff;
}

.dash__details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 65vw;
  max-height: 85vh;
  border-radius: 1rem;
  padding: 2%;
  overflow-y: scroll;
  background-color: #f2f2f2;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 1rem;
}
.dash__details::-webkit-scrollbar {
  display: none;
}
.dash__details .status__updates {
  background-color: #BFBFBF;
  border-radius: 0.5rem;
  width: 60vw;
  margin: 0 auto;
  margin-top: 2%;
}
.dash__details .status__updates table {
  width: 90%;
  margin: auto;
  border-collapse: collapse;
}
.dash__details .status__updates table thead {
  text-align: center;
}
.dash__details .status__updates table thead tr {
  border-bottom: 1px solid #c3c3c3;
}
.dash__details .toolbar {
  background-color: #BFBFBF;
  border-radius: 0.5rem;
  width: 60vw;
  margin: 0 auto;
  margin-top: 2%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 10vh;
}
.dash__details .reprair__cards {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2%;
  width: 60vw;
}
.dash__details .reprair__cards .repair__column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.dash__details .reprair__cards .repair__column .card {
  width: 18vw;
  height: 20vh;
  overflow-y: scroll;
  background-color: #BFBFBF;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 2%;
  overflow-y: scroll;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
}
.dash__details .reprair__cards .repair__column .card h3 {
  align-self: center;
  border-bottom: 1px solid #E4FFFF;
}
.dash__details .reprair__cards .repair__column .card p {
  margin: 2%;
}
.dash__details .reprair__cards .repair__column .card p span {
  color: #BF1a1a;
}
.dash__details .reprair__cards .repair__column .card table {
  width: 100%;
  border-collapse: collapse;
}
.dash__details .reprair__cards .repair__column .card table thead {
  background-color: #021859;
  color: #f2f2f2;
}
.dash__details .reprair__cards .repair__column .card table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}
.dash__details .reprair__cards .repair__column .card:nth-child(1) {
  margin-bottom: 4%;
}
.dash__details .reprair__cards .repair__column .card:nth-child(2) {
  margin-bottom: 4%;
}
.dash__details .reprair__cards .audit__log {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #BFBFBF;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
  width: 40vw;
  height: 65vh;
  margin-top: 2%;
  overflow-y: scroll;
}
.dash__details .reprair__cards .audit__log table {
  width: 90%;
  margin: auto;
  border-collapse: collapse;
  margin-top: 0;
}
.dash__details .reprair__cards .audit__log table thead {
  background-color: #021859;
  color: #f2f2f2;
}
.dash__details .reprair__cards .audit__log table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.admin__dashboard {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #E4FFFF;
}
.admin__dashboard .dash__main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2%;
  min-height: 92vh;
  width: 100vw;
}
.admin__dashboard .repairs__supplier {
  position: absolute;
  bottom: 4vh;
  right: 3vw;
}

.modal__content {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.modal__content .modal__card {
  background-color: #E4FFFF;
  border-radius: 1rem;
  width: 8vw;
  height: 8vw;
  padding: 2%;
  margin-bottom: 2%;
  text-align: center;
  box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/components/admin/dashboard.scss"],"names":[],"mappings":"AAgBA;EACI,yBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AAfJ;AAgBI;EACI,iBAAA;EACA,yBAAA;AAdR;AAeQ;EACI,cA7BN;AAgBN;;AAkBA;EAII,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EArCF,yBAAA;EAJA,0CAAA;EAMA,mBAAA;AAoBF;AAII;EACI,aAAA;AAFR;AAcI;EACI,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AAZR;AAcI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAZR;AAaQ;EACI,YAAA;EACA,WAAA;EACA,qBAAA;AAXZ;AAcI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,WAAA;AAZR;AAaQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EAzEV,0CAAA;AA+DF;AAaY;EACI,iBAAA;EACA,WAAA;EACA,eAAA;AAXhB;AAaY;EACI,cAvFV;EAwFU,iBAAA;AAXhB;AAeI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAbR;AAcQ;EACI,yBAAA;EACA,WAAA;AAZZ;AAcQ;EACI,yBAAA;EACA,WAAA;AAZZ;AAaY;EACI,WAAA;AAXhB;AAaY;EACI,gCAAA;EACA,yBAAA;EACA,cAAA;AAXhB;AAeoB;EACI,yBArHjB;EAsHiB,WAAA;AAbxB;AAmBI;EACI,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AAjBR;AAkBQ;EACI,WAAA;AAhBZ;AAiBY;EACI,gCAAA;AAfhB;AAmBoB;EACI,yBA1IjB;EA2IiB,WAAA;AAjBxB;;AAyBA;EAII,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EAzJF,yBAAA;EAJA,0CAAA;EAMA,mBAAA;AAiIF;AAWI;EACI,aAAA;AATR;AAqBI;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAnBR;AAoBQ;EACI,UAAA;EACA,YAAA;EACA,yBAAA;AAlBZ;AAmBY;EACI,kBAAA;AAjBhB;AAkBY;EACI,gCAAA;AAhBhB;AAqBI;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AAnBR;AAqBI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AAnBR;AAoBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AAlBZ;AAmBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EAlNd,0CAAA;AAkMF;AAkBgB;EACI,kBAAA;EACA,gCAAA;AAhBpB;AAkBgB;EACI,UAAA;AAhBpB;AAiBoB;EACI,cAhOlB;AAiNN;AAkBgB;EACI,WAAA;EACA,yBAAA;AAhBpB;AAiBoB;EACI,yBAAA;EACA,cAAA;AAfxB;AAmB4B;EACI,yBAAA;AAjBhC;AAsBgB;EACI,iBAAA;AApBpB;AAsBgB;EACI,iBAAA;AApBpB;AAyBQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EA3PV,0CAAA;EA6PU,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAvBZ;AAwBY;EACI,UAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;AAtBhB;AAuBgB;EACI,yBAAA;EACA,cAAA;AArBpB;AAyBwB;EACI,yBAAA;AAvB5B;;AAiCA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAhSO;AAkQX;AA+BI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AA7BR;AA+BI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AA7BR;;AAiCA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;AA9BJ;AA+BI;EACI,yBAtTG;EAuTH,mBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;AA7BR","sourcesContent":["$red: #BF1a1a;\n$lightBlue: rgba(126, 209, 242, .5);\n$darkBlue: #E4FFFF;\n$grey: #b3b3b3;\n@mixin shadow{\n  box-shadow: 4px 2px 8px rgba(0, 0, 0, .2);\n}\n\n@mixin card{\n  background-color: #f2f2f2;\n  @include shadow;\n  border-radius: 1rem;\n}\n\n\n\n.dash__header{\n    background-color: #021859;\n    color: #fff;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100vw;\n    padding: 2%;\n    height: 8vh;\n    h1{\n        font-size: 1.5rem;\n        text-transform: uppercase;\n        span{\n            color: $red;\n        }\n    }    \n}\n\n.dash__history{\n    &::-webkit-scrollbar{\n        display: none;\n    } \n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 30vw;\n    height: 85vh;\n    border-radius: 1rem;\n    padding: 2%;\n    overflow-y: scroll;\n    @include card;\n    label{\n        font-size: 1.2rem;\n        align-self: flex-start;\n        color: #333;\n        font-weight: bolder;\n    }\n    .dash__search{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 95%;\n        .dash__search{\n            border: none;\n            height: 3vh;\n            border-radius: .5rem;\n        }\n    }\n    .dash__repairs{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-top: 2%;\n        width: 30vw;\n        .repair__card{\n            width: 8vw;\n            height: 10vh;\n            background-color:#BFBFBF;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            border-radius: .5rem;\n            @include shadow;\n\n            h4{\n                font-size: 1.1rem;\n                color: #333;\n                margin: 1% auto;\n            }\n            h5{\n                color: $red;\n                font-size: 1.1rem;\n            }\n        }\n    }\n    .dash__open{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: flex-start;\n        width: 30vw;\n        background-color: #f2f2f2;\n        border-radius: .5rem;\n        margin-top: 2vh;\n        min-height: 40vh;\n        hr{\n            border:2px solid #021859;\n            width:100%;\n        }\n        .repair{\n            border-collapse: collapse;\n            width: 100%;\n            thead, tr, th, tbody {\n                height: 3vh;\n            }\n            thead{\n                border-bottom: 2px solid $darkBlue;\n                background-color: #021859;\n                color: #f2f2f2;\n            }\n            tbody{\n                tr{\n                    &:nth-child(even){\n                        background-color: $grey;\n                        color: #fff;\n                    }\n                }\n            }\n        }\n    }\n    .search__result{\n        background-color: #fff;\n        width: 30vw;\n        border-radius: .5rem;\n        max-height: 20vh;\n        overflow-y: scroll;\n        table{\n            width: 100%;\n            thead{\n                border-bottom: 2px solid $darkBlue;\n            }\n            tbody{\n                tr{\n                    &:nth-child(even){\n                        background-color: $grey;\n                        color: #fff;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.dash__details {\n    &::-webkit-scrollbar{\n        display: none;\n    }\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    width: 65vw;\n    max-height: 85vh;\n    border-radius: 1rem;\n    padding: 2%;\n    overflow-y: scroll;\n    @include card;\n    .status__updates{\n        background-color: #BFBFBF;\n        border-radius: .5rem;\n        width: 60vw;\n        margin: 0 auto;\n        margin-top: 2%;\n        table{\n            width: 90%;\n            margin: auto;\n            border-collapse: collapse;\n            thead{\n                text-align: center;\n            tr{\n                border-bottom: 1px solid #c3c3c3\n            }\n        }\n        }\n    }\n    .toolbar{\n        background-color: #BFBFBF;\n        border-radius: .5rem;\n        width: 60vw;\n        margin: 0 auto;\n        margin-top: 2%;\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        height: 10vh;\n    }\n    .reprair__cards{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 2%;\n        width: 60vw;\n        .repair__column{\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: flex-start;\n            .card{\n                width: 18vw;\n                height: 20vh;\n                overflow-y: scroll;\n                background-color: #BFBFBF;\n                border-radius: .5rem;\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n                justify-content: flex-start;\n                padding: 2%;\n                overflow-y: scroll;\n                @include shadow;\n                h3{\n                    align-self: center;\n                    border-bottom: 1px solid $darkBlue;\n                }\n                p{\n                    margin: 2%;\n                    span{\n                        color: $red;\n                    }\n                }\n                table{\n                    width: 100%;\n                    border-collapse: collapse;\n                    thead{\n                        background-color: #021859;\n                        color: #f2f2f2;\n                    }\n                    tbody{\n                        tr{\n                            &:nth-child(even){\n                                background-color: #f2f2f2;\n                            }\n                        }\n                    }    \n                }\n                &:nth-child(1){\n                    margin-bottom: 4%;\n                }\n                &:nth-child(2){\n                    margin-bottom: 4%;\n                }\n            }\n    \n        }\n        .audit__log{\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            text-align: center;\n            background-color: #BFBFBF;\n            @include shadow;\n            border-radius: .5rem;\n            width: 40vw;\n            height: 65vh;\n            margin-top: 2%;\n            overflow-y: scroll;\n            table{\n                width: 90%;\n                margin: auto;\n                border-collapse: collapse;\n                margin-top: 0;\n                thead{\n                    background-color: #021859;\n                    color: #f2f2f2;\n                }\n                tbody{\n                    tr{\n                        &:nth-child(even){\n                            background-color: #f2f2f2;\n                        }\n                    }\n                }\n            }\n        }\n    \n    }\n}\n\n.admin__dashboard{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: $darkBlue;\n    .dash__main{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 2%;\n        min-height: 92vh;\n        width: 100vw;\n    }\n    .repairs__supplier{\n        position: absolute;\n        bottom: 4vh;\n        right: 3vw;\n    }\n}\n\n.modal__content{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n    .modal__card{\n        background-color: $darkBlue;\n        border-radius: 1rem;\n        width: 8vw;\n        height: 8vw;\n        padding: 2%;\n        margin-bottom: 2%;\n        text-align: center;\n        box-shadow: 4px 2px 8px rgba(0, 0, 0, .2);\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
